'use client';

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ScanEffortLevel } from '@terra/shared-contracts-applications';
import { terraProxyApiClient } from '../../clients/testerClient';

export const APPLICATION_SCAN_EFFORT_QUERY_KEY = 'application-scan-effort';

export function useApplicationScanEffort({
  applicationId,
  enabled = true,
}: {
  applicationId: string | undefined;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: [APPLICATION_SCAN_EFFORT_QUERY_KEY, applicationId],
    queryFn: () => {
      if (!applicationId) {
        throw new Error('Application ID is required');
      }

      return terraProxyApiClient.getApplicationScanEffort(applicationId);
    },
    enabled: enabled && Boolean(applicationId),
  });
}

export function useUpdateApplicationScanEffort({
  applicationId,
}: {
  applicationId: string | undefined;
}) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (level: ScanEffortLevel) => {
      if (!applicationId) {
        throw new Error('Application ID is required');
      }

      return terraProxyApiClient.updateApplicationScanEffort({
        applicationId,
        level,
      });
    },
    onSuccess: (data) => {
      queryClient.setQueryData(
        [APPLICATION_SCAN_EFFORT_QUERY_KEY, applicationId],
        data,
      );
    },
  });
}
